export default __webpack_public_path__ + "static/Tribal-f6cd4144b9980d0a40b5bb6f0e0fe62a.png";